import React from 'react';
import './ProductCard.css';
import { Product } from '../../../types';
import Icon from '../../atoms/Icon';

export interface ProductCardProps {
  product: Product;
  onClick?: (product: Product) => void;
  onEdit?: (product: Product) => void;
  onDuplicate?: (product: Product) => void;
  onDelete?: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ 
  product, 
  onClick, 
  onEdit, 
  onDuplicate, 
  onDelete 
}) => {
  // Get primary image or first image, if available
  const primaryImage = product.images.find(img => img.isPrimary)?.url || 
                      (product.images.length > 0 ? product.images[0].url : undefined);
  
  const handleClick = () => {
    if (onClick) {
      onClick(product);
    }
  };

  return (
    <div 
      className={`admin-product-card ${product.isActive ? 'active' : 'inactive'}`} 
      onClick={handleClick}
    >
      <div className="admin-product-card-image-container">
        {primaryImage ? (
          <img 
            src={primaryImage} 
            alt={product.name} 
            className="admin-product-card-image" 
          />
        ) : (
          <div className="admin-product-card-image-placeholder">
            <span>No Image</span>
          </div>
        )}
        <div className="admin-product-card-status">
          <span className={`status-indicator ${product.isActive ? 'active' : 'inactive'}`}>
            {product.isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
        <div className="admin-product-card-actions">
          {onEdit && (
            <button 
              className="action-button edit-button" 
              onClick={(e) => {
                e.stopPropagation();
                onEdit(product);
              }}
              aria-label="Edit product"
            >
              <Icon type="edit" size="small" />
            </button>
          )}
          {onDuplicate && (
            <button 
              className="action-button duplicate-button" 
              onClick={(e) => {
                e.stopPropagation();
                onDuplicate(product);
              }}
              aria-label="Duplicate product"
            >
              <Icon type="copy" size="small" />
            </button>
          )}
          {onDelete && (
            <button 
              className="action-button delete-button" 
              onClick={(e) => {
                e.stopPropagation();
                onDelete(product);
              }}
              aria-label="Delete product"
            >
              <Icon type="delete" size="small" />
            </button>
          )}
        </div>
      </div>
      <div className="admin-product-card-content">
        <h3 className="admin-product-card-title">{product.name}</h3>
        <p className="admin-product-card-collection">{product.collection}</p>
        <div className="admin-product-card-details">
          <span>{product.flavors.filter(f => f.available).length} flavors</span>
          <span>{product.sizes.length} sizes</span>
          <span>{product.fillings ? product.fillings.length : 0} fillings</span>
          <span>{product.coverIcingOptions ? product.coverIcingOptions.length : 0} icing</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
